import { useEffect, useState } from "react";
import { Activity, RefreshCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import client from "../api/client";
import "./EmployeeActivity.css";

export default function EmployeeActivity() {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    loadEmployees();
  }, []);

  const loadEmployees = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await client.get("/users");
      const nextEmployees = Array.isArray(response.data) ? response.data : [];

      setEmployees(
        nextEmployees
          .filter((employee) => Number(employee?.id) > 0)
          .sort((left, right) =>
            String(left?.name || "").localeCompare(String(right?.name || ""), "en", {
              sensitivity: "base",
            })
          )
      );
    } catch (err) {
      console.error("Failed to load employees for activity list:", err);
      setError(err?.response?.data?.message || "Unable to load employees right now.");
      setEmployees([]);
    } finally {
      setLoading(false);
    }
  };

  const handleViewHistory = (employee) => {
    if (!employee?.id) {
      setError("No employee is linked to this row.");
      return;
    }

    navigate(`/employee-activity/${employee.id}`, {
      state: { employeeName: employee.name || `Employee #${employee.id}` },
    });
  };

  return (
    <div className="employee-activity-page page-container">
      <header className="employee-activity-header">
        <div>
          <h1 className="employee-activity-title">
            <Activity size={24} strokeWidth={2.2} />
            Employee Activity
          </h1>
          <p className="employee-activity-subtitle">
            Select an employee to view their full activity history.
          </p>
        </div>
      </header>

      <section className="employee-activity-card">
        <div className="employee-activity-card-head">
          <div>
            <h2>Employees</h2>
            <p>{employees.length} employee{employees.length === 1 ? "" : "s"} available.</p>
          </div>
          <button
            type="button"
            className="employee-activity-btn"
            onClick={loadEmployees}
          >
            <RefreshCcw size={16} />
            Refresh
          </button>
        </div>

        {error ? <div className="employee-activity-state is-error">{error}</div> : null}

        <div className="employee-activity-table-wrap">
          <table className="employee-activity-table">
            <thead>
              <tr>
                <th>Employee Name</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="2" className="employee-activity-empty">
                    Loading employees...
                  </td>
                </tr>
              ) : employees.length === 0 ? (
                <tr>
                  <td colSpan="2" className="employee-activity-empty">
                    No employees found.
                  </td>
                </tr>
              ) : (
                employees.map((employee) => (
                  <tr key={employee.id}>
                    <td>{employee.name || `Employee #${employee.id}`}</td>
                    <td>
                      <button
                        type="button"
                        className="employee-activity-link-btn"
                        onClick={() => handleViewHistory(employee)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
